import React from "react";
import "./project.css";
import ToolsSection from "../../components/toolsection/ToolsSection";
import FeedbackSection from "../../components/feedback/FeedbackSection";
import { KeyboardArrowLeft } from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";
const Project = () => {
	const location = useLocation();
	const data = location.state.data;
	return (
		<section
			className="projectpage"
		>
			<div className="projectpage-wrapper">
				<Link to="/projects" style={{ textDecoration: "none" }}>
					<div className="back-btn">
						<span>Go back</span>
					</div>
				</Link>
				<Link to="/projects" style={{ textDecoration: "none" }}>
					<div className="mobile-back-btn">
						<KeyboardArrowLeft className="back-icon" />
					</div>
				</Link>
				<header className="projectpage-header">
					<h1>Welcome to {data.title} Page</h1>
					<h1 className="mobile-header">Peaches Website Page</h1>
					<h3>
						Feel free to visit the website and don't forget to leave a feedback
						and a star if you liked it.
					</h3>
				</header>
				<div className="main-body">
					<ToolsSection data={data} />
					<FeedbackSection />
				</div>
			</div>
		</section>
	);
};

export default Project;
